import React from "react";
import * as utf8 from "utf8";
import type { QueryProps } from "./request";

export const base64Decode = (value: string) => {
    if (value) {
        return typeof atob !== "undefined"
            ? atob(utf8.encode(value))
            : Buffer.from(utf8.encode(value)).toString("ascii");
    }

    return value;
};

export const objectToGetParams = (object: QueryProps) => {
    if (object) {
        const params = Object.entries(object)
            .filter(([, value]) => value !== undefined && value !== null)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);

        return params.length > 0 ? `?${params.join("&")}` : "";
    }

    return "";
};

export const promiseTimeout = <T>(ms: number, promise: Promise<T>) => {
    // Create a promise that rejects in <ms> milliseconds
    const timeout = new Promise((resolve, reject) => {
        const id = setTimeout(() => {
            clearTimeout(id);
            reject(`Timed out in ${ms} ms.`);
        }, ms);
    });

    // Returns a race between our timeout and the passed in promise
    return Promise.race([promise, timeout]);
};

export const orderObjectByKeys = (object: { [key: string]: any }) => {
    return Object.keys(object)
        .sort()
        .reduce((obj, key) => {
            obj[key] = object[key];
            return obj;
        }, {});
};

export const NAVBAR_HEIGHT = 68;

export const scrollToAnchor = (element?: HTMLElement | null) => {
    if (element) {
        const top = element.offsetTop;
        const left = element.offsetLeft;
        window.scrollTo(left, top - NAVBAR_HEIGHT - 20);
    }
};

export const bindHashAnchorLinks = (contentRef: React.RefObject<HTMLDivElement>) => {
    contentRef.current?.querySelectorAll("a[href^='#']").forEach(element => {
        (element as HTMLAnchorElement).onclick = event => {
            const id = element.getAttribute("href")?.split("#")[1];
            if (id) {
                scrollToAnchor(document.getElementById(id));
            }
            event.preventDefault();
            return false;
        };
    });
};
